import useSwr from 'swr';

const fetchApi = (url: string) => fetch(url).then(response => response.json());

const useLocalApi = url => {
  const { data } = useSwr(`/api${url}`, fetchApi);

  return data;
};

export default useLocalApi;
